import { useState, useRef, useEffect } from "react";
import Webcam from "react-webcam";
import { hostName } from "../config/config";
import ConfirmationPopup from "./common/ConfirmationPopup";

function Capture({
  isView,
  savedImages,
  onImagesChange,
  onImageDelete,
  reset,
  mandatoryFieldRef,
  fieldValue,
  singleImageCapture,
  allowPdf
}) {
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const [facingMode, setFacingMode] = useState("user");
  const webcamRef = useRef(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    itemIndex: 0,
  });

  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  useEffect(() => {
    if (reset) {
      setCapturedImages([]);
      onImagesChange([], "");
      if (mandatoryFieldRef.current[fieldValue]) {
        mandatoryFieldRef.current[fieldValue].value = "";
      }
    }
    if (savedImages) {
      setCapturedImages(savedImages);
    }
  }, [reset, onImagesChange, mandatoryFieldRef, fieldValue, savedImages]);

  const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: facingMode,
  };

  const updateImages = (newImages, nameOfFile) => {
    setCapturedImages(newImages);
    if (onImagesChange) {
      onImagesChange(newImages, nameOfFile);
    }
  };

  const deleteImages = (newImages, index) => {
    setCapturedImages(newImages);
    if (onImageDelete) {
      onImageDelete(index);
    }
  };

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const newImages = singleImageCapture
        ? [imageSrc]
        : [...capturedImages, imageSrc];
      updateImages(newImages, "");
      setShowCamera(false);
    }
  };

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  const closeCamera = () => {
    setShowCamera(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const nameOfFile  = file.name;
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = singleImageCapture
          ? [reader.result]
          : [...capturedImages, reader.result];
        updateImages(newImages, nameOfFile);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (indexToRemove) => {
    const newImages = capturedImages.filter(
      (_, index) => index !== indexToRemove
    );
    if (mandatoryFieldRef.current[fieldValue]) {
        mandatoryFieldRef.current[fieldValue].value = "";
      }
    deleteImages(newImages, indexToRemove);
    setShowConfirmationPopup(
      {
        show: false,
        itemIndex: 0
      }
    )
  };

  const closePopup = () => {
    setShowConfirmationPopup(
      {
        show: false,
        itemIndex: 0
      }
    )
  }

  return (
    <div className="d-flex" style={{ flexDirection: "column" }}>
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText="Delete Image"
        infoText="Please confirm if you want to delete the selected image"
        cancelText="Cancel"
        submitText="Delete"
        onCancel={() => { closePopup() }}
        onSubmit={() => {
          removeImage(
            showConfirmationPopup.itemIndex,
          )
        }}
      />
      <div className="d-flex gap-3 pb-4 align-items-center">
        {!isView && (
          <input
            type="file"
            accept={allowPdf ? ".jpg, .jpeg, .png, .gif, .pdf" : ".jpg, .jpeg, .png, .gif"}
            onChange={handleFileChange}
            className="form-control"
            id="chooseFiles"
            disabled={singleImageCapture && capturedImages.length >= 1}
            ref={(el) => (mandatoryFieldRef.current[fieldValue] = el)}
          />
        )}

        {!showCamera && !isView && (
          <div>
            <i
              className="fa-solid fa-camera fa-xl mainCamera"
              onClick={() => {
                if (!(singleImageCapture && capturedImages.length >= 1)) {
                  setShowCamera(true);
                }
              }}
              title="Open Camera"
              style={{
                cursor:
                  singleImageCapture && capturedImages.length >= 1
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  singleImageCapture && capturedImages.length >= 1 ? 0.5 : 1,
              }}
            ></i>
          </div>
        )}
      </div>

      {showCamera && (
        <div>
          <Webcam
            audio={false}
            ref={webcamRef}
            height={280}
            screenshotFormat="image/jpeg"
            width={290}
            videoConstraints={videoConstraints}
          />
          <div
            className="d-flex flex-wrap gap-3"
            style={{ justifyContent: "center" }}
          >
            <i
              className="fa-solid fa-camera fa-xl"
              onClick={capturePhoto}
              disabled={singleImageCapture && capturedImages.length >= 1}
              style={{ cursor: "pointer" }}
              title="Capture Photo"
            ></i>
            <i
              className="fa-solid fa-camera-rotate fa-xl"
              onClick={switchCamera}
              style={{ cursor: "pointer" }}
              title="Switch Camera"
            ></i>
            <i
              className="fa-solid fa-xmark fa-xl"
              onClick={closeCamera}
              style={{ cursor: "pointer" }}
              title="Close Camera"
            ></i>
          </div>
        </div>
      )}

      {capturedImages.length > 0 && (
        <div style={{ marginTop: "1rem" }}>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {capturedImages.map((img, index) => {
              if(img !== null && img !== undefined && img !== ""){
                let pdfurl; let pdfName;
                if(img?.includes(".pdf")){
                  pdfName = new URL(img).searchParams.get("filename");
                  pdfurl = img.split("?filename=")[0];
                }
                return(<>
                  {img?.includes(".pdf") 
                    ? <p className="form-group d-flex flex-row">
                      <a href={pdfurl} target="_blank" rel="noopener noreferrer" >{pdfName}</a>
                      {!isView && (
                      <i
                        className="fa-solid fa-xmark"
                        onClick={() => setShowConfirmationPopup({
                          show: true,
                          itemIndex: index
                        })}
                        style={{
                          
                          backgroundColor: "transparent",
                          color: "black",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                      ></i>
                    )}
                      </p>
                     : <div
                    key={index}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "200px",
                      border: "2px solid #000",
                    }}
                  >
                    <img
                      src={
                        img?.includes("data:image")
                          ? img
                          : ImageProxyBaseUrl + encodeURIComponent(img)
                      }
                      alt={`Captured ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
    
                    {!isView && (
                      <i
                        className="fa-solid fa-xmark"
                        onClick={() => setShowConfirmationPopup({
                          show: true,
                          itemIndex: index
                        })}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "transparent",
                          color: "black",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                      ></i>
                    )}
                  </div>}</>
                )
              }
})}
          </div>
        </div>
      )}
    </div>
  );
}

export default Capture;
